import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'my-angular-app';
  @ViewChild('pageScroll') pageScroll!: ElementRef<HTMLElement>;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    public router: Router,
    public matIconRegistry: MatIconRegistry,
    public domSanitizer: DomSanitizer,
  ) {
    const svgIconUrl = [
      { name: 'ua', link: 'assets/img/ua.svg' },
      { name: 'en', link: 'assets/img/en.svg' },
    ];
    svgIconUrl.forEach((icon) => {
      const safeSvgIcon = this.domSanitizer.bypassSecurityTrustResourceUrl(icon.link);
      this.matIconRegistry.addSvgIcon(icon.name, safeSvgIcon);
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const utmSource = params['utm_source'];
      if (utmSource) {
        localStorage.setItem('utm_source', utmSource);
        this.router.navigate([], {
          queryParams: {
            'utm_source': null,
          },
          queryParamsHandling: 'merge',
        });
      }
    });
  }

  ngAfterViewInit() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          this.pageScroll.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
  }
}
